<template>
        <v-card
          style="display: flex;"
          outlined
          @click="$emit('click')"
        >
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="text-h5 mb-1">
              {{getTitle}}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{getText}}
            </v-list-item-subtitle>
            <slot></slot>
          </v-list-item-content>
        </v-list-item>
      </v-card>
</template>

<script>

export default {
  name: 'RatingDashboardCard',
  mixins: [],
  props: {
    title: { type: String, required: true },
    text: { type: String, required: true }
  },
  computed: {
    getTitle(){ return this.title; },
    getText(){ return this.text; },
  },
};
</script>

<style scoped>
  .v-application .text-h5.v-list-item__title {
    font-size: 4rem!important;
    font-weight: 100;
  }
</style>